import { useState } from "react";

import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";

import WebhookActionsDropdown from "./WebhookActionsDropdown";
import WebhookDialog from "./WebhookDialog";

import type { Webhook } from "../../types";

interface TableProps {
  webhooks: Webhook[];
}

type Action = "edit" | "delete" | "test";

export default function WebhooksDesktopTable({ webhooks }: TableProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<Action>(null);
  const [selectedWebhookId, setSelectedWebhookId] = useState<string>(null);

  const selectedWebhook =
    selectedWebhookId && webhooks.find(({ id }) => id === selectedWebhookId);

  return (
    <>
      <Table>
        <thead>
          <tr>
            <TableHead>Webhook name</TableHead>
            <TableHead>URL</TableHead>
            <TableHead>Event</TableHead>
            <TableHead />
          </tr>
        </thead>

        <tbody>
          {webhooks.map((webhook) => {
            const { name, id, url, events } = webhook;

            return (
              <TableRow key={id}>
                <TableCell className="text-md-bold">{name}</TableCell>

                <TableCell className="text-button-xs">{url}</TableCell>

                <TableCell className="text-button-xs">
                  {events.length === 1
                    ? events[0]
                    : `${events[0]} (+ ${events.length - 1} more)`}
                </TableCell>

                <TableCell>
                  <WebhookActionsDropdown
                    openActionModal={(newAction) => {
                      setSelectedWebhookId(id);
                      setAction(newAction);
                      setIsOpen(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
      {selectedWebhook && (
        <WebhookDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          action={action}
          webhook={selectedWebhook}
        />
      )}
    </>
  );
}
